'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREATE_NEW_THREAD = exports.UPDATE_THREAD_CURRENT_URL = exports.SET_THREADS_SUCCESS = undefined;

var _createAsyncActionTypes = require('conversations-async-data/async-action/createAsyncActionTypes');

var SET_THREADS_SUCCESS = exports.SET_THREADS_SUCCESS = 'SET_THREADS_SUCCESS';
var UPDATE_THREAD_CURRENT_URL = exports.UPDATE_THREAD_CURRENT_URL = 'UPDATE_THREAD_CURRENT_URL';

var CREATE_NEW_THREAD = exports.CREATE_NEW_THREAD = (0, _createAsyncActionTypes.createAsyncActionTypes)('CREATE_NEW_THREAD');